var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"teachingMode"},[_c('div',{staticClass:"tm_main"},[_c('appListView',{directives:[{name:"show",rawName:"v-show",value:(_vm.showTag == 0),expression:"showTag == 0"}],ref:"appListViewRef"}),(_vm.showTag == 1 && _vm.detailId)?_c('AppDetailView',{ref:"AppDetailViewRef",attrs:{"id":_vm.detailId}}):_vm._e()],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }